import React, { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TagValueModel } from "@/utils/Types.ts";
import { FolderIcon } from "lucide-react";

interface ProjectDropdownProps {
  onSelectionChange: (selectedValue?: TagValueModel) => void;
  defaultValue?: string;
  defaultText?: string;
  values?: TagValueModel[];
  isFetching?: boolean;
  isError?: boolean;
}

const ProjectDropdown: React.FC<ProjectDropdownProps> = ({
  onSelectionChange,
  defaultValue = "",
  defaultText = "Select An Optoin",
  values,
  isFetching,
  isError,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);

  useEffect(() => {
    //find which index contains our default value
    if (values) {
      const index = values.findIndex((li: TagValueModel) => li.path === defaultValue);
      if (index > -1) {
        setSelectedIndex(index);
        onSelectionChange(values[index]);
      }
    } else {
      setSelectedIndex(undefined);
      onSelectionChange(undefined);
    }
  }, [values]);

  const handleSelectChange = (value: string) => {
    const selectedIndex = parseInt(value, 10);
    setSelectedIndex(selectedIndex);

    // Pass selection to parent component
    if (!isNaN(selectedIndex)) {
      onSelectionChange(values![selectedIndex]);
    } else {
      onSelectionChange(undefined);
    }
  };

  return (
    <Select onValueChange={handleSelectChange} value={selectedIndex?.toString()}>
      <SelectTrigger className="w-auto flex items-center gap-2">
        <FolderIcon strokeWidth={2.5} className="h-4 w-4 text-muted-foreground" />
        <SelectValue placeholder={defaultText} className="pl-1" />
      </SelectTrigger>
      <SelectContent>
        {isFetching && <div className="p-2">Loading…</div>}
        {isError && <div className="p-2 text-red-500">Error loading</div>}
        {values &&
          values.map((v, index) => (
            <SelectItem key={index} value={index.toString()}>
              {v.label}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};

export default ProjectDropdown;
